import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const getData = async (params: object) => {
  return await GET({ url: Api.propKpiNoCheck, params, showError: false })
}
export const usePropKpiNoCheck = async (params: object) => {
  return await GET({ url: Api.usePropKpiNoCheck, params, showError: false })
}
export const usePropSettingTips = async (params: object) => {
  return await GET({ url: Api.usePropSettingTips, params, showError: false })
}
